import styled from '@emotion/styled';

import { ListItem } from 'components/interventions/modals/ManageChecklistsGroup/UI';
import { css } from 'config/emotionCss';

export const listWrapperStyle = css`
  height: 20rem;
`;

export const ImportListItem = styled(ListItem)`
  border-block-end: none;

  /* ui/base Checkbox wraps the antd checkbox in an extra Flex container */
  > .ant-flex {
    width: 100%;
  }
`;

export const checkboxStyle = css`
  width: 100%;
  gap: 12px;

  .ant-checkbox-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-inline: 0;
  }
`;
